<div class="filter-component">
  @if(currentTab.id != 1){
  <button
    class="expansion-filter"
    mat-menu-item
    #ramosTrigger="matMenuTrigger"
    [matMenuTriggerFor]="ramos"
  >
    <div class="expansion-div">
      <ng-icon name="heroChevronLeftMini" class="icon-expansion" />
      <ng-icon name="code-branch" class="expansion-icon-text" />
      <!-- @if(currentTab.id == 1){
        <span class="filter-text">Ramos</span>
        }  -->
      @if(currentTab.id != 1){
      <span class="filter-text">Subramos ({{ currentTab.txt }})</span>
      }
      <ng-container *ngIf="getRamosCount() as cnt"> ({{ cnt }}) </ng-container>
    </div>
  </button>

  <mat-menu #ramos="matMenu" class="container-menu" xPosition="before">
    <sub-filtro-ramos
      [(filtroRamo)]="filtroRamo"
      [currentTab]="currentTab"
    ></sub-filtro-ramos>
  </mat-menu>
  }

  <button
    matButton
    mat-menu-item
    #periodoCotacoesTrigger="matMenuTrigger"
    [matMenuTriggerFor]="periodoCotacoes"
    class="expansion-filter"
  >
    <div class="expansion-div">
      <ng-icon name="heroChevronLeftMini" class="icon-expansion" />
      <ng-icon name="heroClockMicro" class="expansion-icon-text" />
      <span class="filter-text">Período da cotações (1)</span>
    </div>
  </button>

  <mat-menu
    #periodoCotacoes="matMenu"
    class="container-menu"
    xPosition="before"
  >
    <sub-filtro-periodo-cotacoes></sub-filtro-periodo-cotacoes>
  </mat-menu>

  <button
    matButton
    mat-menu-item
    #origemCotacoesTrigger="matMenuTrigger"
    [matMenuTriggerFor]="origemCotacoes"
    class="expansion-filter"
  >
    <div class="expansion-div">
      <ng-icon name="heroChevronLeftMini" class="icon-expansion" />
      <ng-icon name="heroMapPinSolid" class="expansion-icon-text" />
      <span class="filter-text">Origem das cotações (1)</span>
    </div>
  </button>

  <mat-menu #origemCotacoes="matMenu" class="container-menu" xPosition="before">
    <sub-filtro-origem-cotacoes></sub-filtro-origem-cotacoes>
  </mat-menu>

  <button
    class="expansion-filter"
    mat-menu-item
    #usuariosTrigger="matMenuTrigger"
    [matMenuTriggerFor]="usuarios"
    *ngIf="
      (listaUsuarios?.ativos && listaUsuarios?.ativos.length) ||
      (listaUsuarios?.inativos && listaUsuarios?.inativos.length)
    "
  >
    <div class="expansion-div">
      <ng-icon name="heroChevronLeftMini" class="icon-expansion" />
      <ng-icon name="heroUserGroupSolid" class="expansion-icon-text" />
      <span class="filter-text"
        >Usuários
        <ng-container *ngIf="getUsersCount() as cnt">
          ({{ cnt }})
        </ng-container></span
      >
    </div>
  </button>

  <mat-menu #usuarios="matMenu" class="container-menu" xPosition="before">
    <sub-filtro-usuarios
      [listaUsuarios]="listaUsuarios"
      [(filtroUsuario)]="filtroUsuario"
      isEmail="true"
    ></sub-filtro-usuarios>
  </mat-menu>

  <button
    matButton
    mat-menu-item
    #statusNegociosTrigger="matMenuTrigger"
    [matMenuTriggerFor]="statusNegocio"
    class="expansion-filter"
  >
    <div class="expansion-div">
      <ng-icon name="heroChevronLeftMini" class="icon-expansion" />
      <ng-icon name="heroCalculatorSolid" class="expansion-icon-text" />
      <span class="filter-text"
        >Status do Negócio<ng-container *ngIf="getStatusCount() as cnt">
          ({{ cnt }})
        </ng-container></span
      >
    </div>
  </button>

  <mat-menu #statusNegocio="matMenu" class="container-menu" xPosition="before">
    <sub-filtro-status-negocio
      [listaStatusNegocio]="listaStatusNegocio"
      (atualizaFiltroStatusNegocio)="atualizaFiltroStatusNegocio($event)"
    ></sub-filtro-status-negocio>
  </mat-menu>
</div>
